import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPhotoCarouselDot } from './PhotoCarouselDot.styles';

/**
 * Shows an individual pagination dot. Used by `PhotoCarouselDots`.
 *
 * @since 8.66.0
 */
export var PhotoCarouselDot = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPhotoCarouselDot, _extends({
    ref: forwardedRef
  }, props));
});
PhotoCarouselDot.displayName = 'PhotoCarouselDot';